/**
 * sl-4wjh.2.2: Transcription feature tab.
 * Thin wrapper around CapabilityFeatureTab for capability='audio'.
 */
import type { AnalyticsPeriodRange, ContextType } from '../types';
import { CapabilityFeatureTab } from './capability-feature-tab';

export interface TranscriptionTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  context: ContextType;
}

export const TranscriptionTab = (props: TranscriptionTabProps) => (
  <CapabilityFeatureTab
    {...props}
    capability="audio"
    cacheKey="transcription"
    countCardKey="transcriptions"
    countCardDefault="Transcriptions"
  />
);
